import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { EmailLoginService } from 'src/Services/emaillogin.service';
import { FilterModel } from 'src/Models/filterModel';
import { userModel } from 'src/Models/TracItModel';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-tracIt-email-varification',
  templateUrl: './email-varification.component.html',
  styleUrls: ['./email-varification.component.css']
})
export class TracItEmailVarificationComponent implements OnInit {
  quaryValues: string = '';
  filterModel = new FilterModel();
  blockedDocument: boolean = false;
  userModel = new userModel();

  constructor(private readonly activedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly emailLoginService: EmailLoginService,
    private readonly toastr: ToastrService) {

  }

  ngOnInit() {
    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {

          this.quaryValues = params['id'];
          this.filterModel.emailKey = params['id'];
          this.isValidTracItEmailKey();
        }
        else {
          this.router.navigate(['login/' + this.quaryValues]);
        }
      }
      else {
        this.router.navigate(['login/' + this.quaryValues]);
      }
    });
  }

  isValidTracItEmailKey() {
    this.blockedDocument = true;
    this.emailLoginService.isValidTracItEmailKey(this.filterModel).subscribe(
      data => {
        this.blockedDocument = false;

        if (data["status"] == "Success") {
          this.userModel = data["usersModel"];
          if (this.userModel != null) {
            if (data["usersModel"].listOfProducts.length > 0) {
              sessionStorage.setItem('UserId', this.userModel.userId);
              sessionStorage.setItem('LastLogin', this.userModel.lastLogin);
              sessionStorage.setItem('isUserByPass', 'Login');
              let FirstLastName = this.userModel.firstName + ' ' + this.userModel.lastName;
              if (FirstLastName.trim() != '')
                sessionStorage.setItem('FirstLastName', FirstLastName);
              else
                sessionStorage.setItem('FirstLastName', this.userModel.userName);

              let Tool: string = data["usersModel"].listOfProducts[0].productName.toLowerCase();
              let UserAccessibleTools: string = ''

              for (let iCounter = 0; iCounter < data["usersModel"].listOfProducts.length; iCounter++) {
                UserAccessibleTools += data["usersModel"].listOfProducts[iCounter].productName + ',';
              }
              sessionStorage.setItem('ClientAccessibleTools', UserAccessibleTools.substring(0, UserAccessibleTools.length - 1).toLowerCase());
              sessionStorage.setItem('CompanyId', this.userModel.companyId);
              sessionStorage.setItem('IsICalSubscription', this.userModel.isICalSubscription);
              sessionStorage.setItem('EncyUserId', this.userModel.encyUserId);
              sessionStorage.setItem('CompanyName', this.userModel.companyName);
              
                sessionStorage.setItem('ClientLoginTool', 'actionitem');
                sessionStorage.setItem('emailProductId', data['productId']);
                sessionStorage.setItem('emailActionId', data['actionId']);
                sessionStorage.setItem('emailUpdatedId', data['updateId']);
                sessionStorage.setItem('emailBriefingId', data['briefingId']);
                sessionStorage.setItem('emailUserId', this.userModel.userId);
                if (data['actionId'] != 0)
                  sessionStorage.setItem('emailDeadlineDate', this.userModel.deadlineDateFromAction);
                else if (data['updateId'] != 0)
                  sessionStorage.setItem('emailDeadlineDate', this.userModel.deadlineDateFromUpdate);
                else if (data['briefingId'] != 0)
                  sessionStorage.setItem('emailDeadlineDate', this.userModel.deadlineDateFromBriefing);
                else
                  sessionStorage.setItem('emailDeadlineDate', '');
                this.router.navigate(['/trac-it/Calendar']);
            }
            else {
              this.showMessage("You don't have access to any Tool. Please contact administrator.", 'Error', 'error');
              this.router.navigate(['/login']);
            }
          }
        }
        else if (data["status"] == "Email Token/Key Expired") {
          this.userModel = data["usersModel"];
          if (this.userModel != null) {
            if (data["usersModel"].listOfProducts.length > 0) {
              sessionStorage.setItem('UserId', this.userModel.userId);
              sessionStorage.setItem('LastLogin', this.userModel.lastLogin);
              sessionStorage.setItem('isUserByPass', 'Login');
              let FirstLastName = this.userModel.firstName + ' ' + this.userModel.lastName;
              if (FirstLastName.trim() != '')
                sessionStorage.setItem('FirstLastName', FirstLastName);
              else
                sessionStorage.setItem('FirstLastName', this.userModel.userName);

              let Tool: string = data["usersModel"].listOfProducts[0].productName.toLowerCase();
              let UserAccessibleTools: string = ''

              for (let iCounter = 0; iCounter < data["usersModel"].listOfProducts.length; iCounter++) {
                UserAccessibleTools += data["usersModel"].listOfProducts[iCounter].productName + ',';
              }
              sessionStorage.setItem('ClientAccessibleTools', UserAccessibleTools.substring(0, UserAccessibleTools.length - 1).toLowerCase());
              sessionStorage.setItem('CompanyId', this.userModel.companyId);
              sessionStorage.setItem('IsICalSubscription', this.userModel.isICalSubscription);
              sessionStorage.setItem('EncyUserId', this.userModel.encyUserId);
              sessionStorage.setItem('CompanyName', this.userModel.companyName);

                sessionStorage.setItem('ClientLoginTool', 'actionitem');
                sessionStorage.setItem('emailUserId', this.userModel.userId);
                sessionStorage.setItem('displayMessage', data["status"]);
                this.router.navigate(['/trac-it/Dashboard']);
            }
            else {
              this.showMessage("You don't have access to any Tool. Please contact administrator.", 'Error', 'error');
              this.router.navigate(['/login']);
            }
          }
        }
        else {
          this.showMessage(data["status"] + ' - user not have access', 'Error', 'error');
          this.router.navigate(['/login']);
        }
        this.blockedDocument = false;
      },
      error => {
        this.blockedDocument = false;
        console.log(error);
        this.router.navigate(['login']);
      }
    );
  }


  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

}
